function getHeaderScrollOffset() {
  const header = document.querySelector('[data-testid="main-header"]');
  return header?.getBoundingClientRect().height ?? 104;
}

/** Scroll so the element sits flush below the sticky site header. */
export function scrollToElementById(elementId) {
  const el = document.getElementById(elementId);
  if (!el) return false;

  const offset = getHeaderScrollOffset();
  const top = el.getBoundingClientRect().top + window.pageYOffset - offset;
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  window.scrollTo({
    top: Math.max(0, top),
    behavior: prefersReducedMotion ? 'auto' : 'smooth',
  });

  return true;
}

/** Retry scroll until the target page has mounted. */
export function scheduleScrollToElementById(elementId, { delayMs = 0, maxAttempts = 30 } = {}) {
  let attempts = 0;
  let cancelled = false;
  let timeoutId;
  let rafId;

  const run = () => {
    if (cancelled) return;

    if (document.activeElement instanceof HTMLElement) {
      document.activeElement.blur();
    }
    if (scrollToElementById(elementId)) return;

    attempts += 1;
    if (attempts < maxAttempts) {
      rafId = requestAnimationFrame(run);
    }
  };

  timeoutId = window.setTimeout(() => {
    if (!cancelled) {
      rafId = requestAnimationFrame(run);
    }
  }, delayMs);

  return () => {
    cancelled = true;
    window.clearTimeout(timeoutId);
    if (rafId) cancelAnimationFrame(rafId);
  };
}

/** Parse internal footer hrefs like `/about#team` or `/projects?category=habitat`. */
export function parseFooterHref(href) {
  const [pathAndSearch, hashPart] = href.split('#');
  const [pathname, searchPart] = pathAndSearch.split('?');
  const search = searchPart ? `?${searchPart}` : '';
  const hash = hashPart ? `#${hashPart}` : '';

  return { pathname, search, hash };
}
